import { Component, OnInit, Injector, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, Validators, FormGroup, FormControl, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { DialogData } from 'app/core/interfaces/dialog';
import { paymentI } from 'app/core/interfaces/payment';
import { procedureI } from 'app/core/interfaces/procedure';
import { openingHourI } from 'app/core/interfaces/schedule';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { ProcedureService } from 'app/core/http/services/procedure.service';
import { Healthcareservice } from 'app/core/interfaces/healthcareservice';
import { procedureFilter } from 'app/core/data/forms.json';
import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

@Component({
  selector: 'page-procedure-registration',
  templateUrl: './procedure-registration.component.html',
  styleUrls: ['./procedure-registration.component.scss'],
})
export class ProcedureRegistrationComponent extends BaseComponent implements OnInit {
  public form: FormGroup;
  public procedure: procedureI = <procedureI>{};
  public hours: openingHourI[] = [];
  public paymentMethods: paymentI[] = [];
  public titles = ['horários do exame', 'Formas de pagamento'];
  public invalidForm = false;
  public tiposProcedure: number = 0;
  public filterTipos = procedureFilter;
  public serviceDealers = [
    { display: 'Serviço realizado diretamente pelo especialista', value: 'Especialista' },
    { display: 'Serviço laudado posteriormente pelo especialista', value: 'Organização' },
  ];

  public mode = 'CREATE';

  public organizationLogged: any = {};

  public selectedTussCode: string | null = null;
  public tussProcedures: any[] = [];
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger!: MatAutocompleteTrigger;

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private fb: FormBuilder,
    private injector: Injector,
    private healthcareService: ProcedureService,
  ) {
    super(injector);
    this.form = this.fb.group({
      name: new FormControl('', [Validators.required, this.validOptionValidator.bind(this)]),
      description: new FormControl('', [Validators.required]),
      extraDetails: new FormControl('', [Validators.nullValidator]),
      serviceDealer: new FormControl('Especialista', [Validators.nullValidator]),
      price_high: new FormControl('', [Validators.required, this.priceValidator]),
      status: new FormControl(true, [Validators.required]),
      comments: new FormControl('', [Validators.nullValidator]),
      appointmentRequired: new FormControl(false, [Validators.nullValidator]),
      serviceType: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    const userLogged = this.getUserLogged();

    this.organizationLogged = {
      organization_id: userLogged.id,
      name: userLogged.alias,
      email: userLogged?.email,
    };

    this.mode = this.data.param.mode;

    if (this.mode == 'UPDATE') {
      this.procedure = this.data.param.procedure;
      this.setValueForm(this.procedure);
      this.getTussBYPrefix(this.procedure?.name);
    }

    this.procedure.hasSchedule = true;
    this.showSuccessMessage = false;
    this.showErrorMessage = false;

    this.form.get('name')!.valueChanges.subscribe((value: string) => {
      if (value && value.length >= 2) {
        this.getTussBYPrefix(value);
      } else {
        this.tussProcedures = [];
      }

      this.form.get('name')!.updateValueAndValidity({ emitEvent: false });
    });
  }

  setValueForm(procedure: any): void {
    this.form.patchValue({
      name: procedure.name,
      description: procedure.description,
      extraDetails: procedure.extraDetails,
      price_high: procedure.price_high,
      serviceType: procedure.serviceType,
      status: procedure.status,
    });

    this.form.controls['serviceDealer'].disable();
  }

  priceValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    // Handle null/undefined
    if (value === null || value === undefined || value === '') {
      return { required: true };
    }

    let numeric: number;

    if (typeof value === 'string') {
      // Remove currency symbols and format string to parseable number
      const cleaned = value
        .replace(/[R$\s]/g, '')
        .replace(/\./g, '')
        .replace(',', '.');
      numeric = parseFloat(cleaned);
    } else if (typeof value === 'number') {
      numeric = value;
    } else {
      return { invalidPrice: true };
    }

    if (isNaN(numeric) || numeric <= 0) {
      return { invalidPrice: true };
    }

    return null;
  }

  getTussBYPrefix(prefix: string) {
    let params = new HttpParams();
    params = params.set('prefix', prefix);
    params = params.set('limit', 20);

    this.healthcareService.getTussByPrefix(params).subscribe({
      next: (tuss: any) => {
        this.tussProcedures = tuss?.items ?? [];

        if (this.tussProcedures.length == 0) {
          const control = this.form.get('name');
          if (control) {
            control.setErrors({ invalidOption: true });
            control.markAsTouched();
          }

          return;
        }

        this.form.get('name')!.updateValueAndValidity({ emitEvent: false });
      },
      error: (error: HttpErrorResponse) => {
        console.error('Falha ao buscar error');

        this.tussProcedures = [];
      },
    });
  }

  onInputFocus() {
    if (!this.autocompleteTrigger.panelOpen) {
      this.autocompleteTrigger.openPanel();
    }
  }

  validOptionValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value?.trim();
    if (!value) return null;

    const found = this.tussProcedures.find((tuss) => tuss.termo.toLowerCase() === value.toLowerCase());

    if (found) {
      this.selectedTussCode = found.codigo;
      return null;
    }

    this.selectedTussCode = null;
    return { invalidOption: true };
  }
  create() {
    this.showErrorMessage = false;
    this.showSuccessMessage = false;

    if (this.form.invalid) {
      this.showErrorMessage = true;
      this.showSuccessMessage = false;
      this.loading = false;
      return;
    }

    const inputFormData = this.form.value;
    const healthcareService: Healthcareservice = {
      ...inputFormData,
      tuss_code: this.selectedTussCode,
      specialty_code: this.selectedTussCode || undefined,
      specialty: inputFormData.name,
      organization: {
        organization_id: this.organizationLogged.organization_id,
        name: this.organizationLogged.name,
      },
    };

    this.healthcareService.create(healthcareService).subscribe({
      next: (restHealthcare) => {
        this.showSuccessMessage = true;

        this.openSnackBar('Exame/Procedimento cadastrado com sucesso', 'success');

        setTimeout(() => {
          this.dialogRef.close();
        }, 1000);
      },
      error: (error: HttpErrorResponse) => {
        this.showErrorMessage = true;
        this.messageError = error.error.message;
      },
    });
  }

  markAsTouched() {
    for (var i in this.form.controls) {
      this.form.controls[i].markAsTouched();
    }
  }

  save() {
    this.showErrorMessage = false;
    this.showSuccessMessage = false;

    if (this.form.invalid) {
      this.showErrorMessage = true;
      this.showSuccessMessage = false;
      this.loading = false;
      return;
    }

    const inputFormData = this.form.getRawValue();
    const healthcareService: Healthcareservice = {
      ...inputFormData,
      tuss_code: this.selectedTussCode,
      specialty_code: this.selectedTussCode || this.procedure.specialty_code,
      specialty: inputFormData.name,
      organization: {
        organization_id: this.organizationLogged.organization_id,
        name: this.organizationLogged.name,
      },
    };

    this.healthcareService.update(this.procedure.healthcareservice_id!, healthcareService).subscribe({
      next: (restHealthcare) => {
        this.showSuccessMessage = true;
      },
      error: (error: HttpErrorResponse) => {
        this.showErrorMessage = true;
        this.messageError = error.error.message;
      },
    });
  }
}
